module.exports = __webpack_public_path__ + "static/media/reseech-decor3.03c0d1ed.png";